<div [id]="categoryType" class="category-content">
    <div class="tabs">
        @for (group of groups; track group) {
            <a class="tab-btn" [class.active]="group.name === currentGroup.name" (click)="setGroup(group)">{{group.name.length === 1 ? 'Grupo ' + group.name : group.name}}</a>
        }
    </div>

    @for (group of groups; track group) {
        <app-category-group-component [category]="tournamentCategory" [group]="group" *ngIf="currentGroup.name === group.name" ></app-category-group-component>
    }
</div>